"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7091],{

/***/ 970870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ WhatsAppIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function WhatsAppIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 34.886,
        height: props.size || 34.886,
        viewBox: "0 0 34.886 34.886"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 0h34.886v34.886H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.444 30.611h-.029a13.41 13.41 0 01-7.207-2.121l-4.991 1.3 1.338-4.851-.318-.5a13.134 13.134 0 01-2.018-7c0-11.7 14.3-17.554 22.575-9.283 8.256 8.179 2.46 22.455-9.35 22.455z",
                fill: "#1e9848",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.684 20.702l-.012.1c-.4-.2-2.352-1.154-2.715-1.286-.816-.3-.586-.048-2.152 1.746-.233.26-.464.279-.86.1a10.8 10.8 0 01-3.2-1.976 12.074 12.074 0 01-2.209-2.755c-.39-.673.426-.769 1.168-2.175a.732.732 0 00-.033-.7c-.1-.2-.894-2.156-1.227-2.936s-.648-.679-.894-.679a1.981 1.981 0 00-1.821.458c-2.148 2.361-1.606 4.8.232 7.386 3.612 4.727 5.536 5.6 9.055 6.806a5.506 5.506 0 002.5.161 4.1 4.1 0 002.683-1.9 3.294 3.294 0 00.24-1.9c-.1-.18-.359-.279-.759-.459z",
                fill: "#fff"
            })
        ]
    }));
}


/***/ }),

/***/ 57091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _index_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979021);
/* harmony import */ var _assets_svgExports_WhatsAppIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(970870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(667294);
/* harmony import */ var _utils_whatsappMessageRender__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(472579);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(299375);
/**
 * This is a reusable component for whatsapp functionality
 * desktop views of multiple headers
 */ 





var WhatsAppIconComp = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showWANo = ref[0], setShowWANo = ref[1];
    var storePhone = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().storePhone;
    var onContactBtnClick = function() {
        (0,_utils_whatsappMessageRender__WEBPACK_IMPORTED_MODULE_4__/* .whatsappMessageRender */ .L)();
    };
    return !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_styles__WEBPACK_IMPORTED_MODULE_1__/* .MenuItem */ .sN, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WhatsAppIcon__WEBPACK_IMPORTED_MODULE_2__/* .WhatsAppIcon */ .y, {
                onClick: function() {
                    return setShowWANo(!showWANo);
                },
                size: "24"
            }),
            !!storePhone && showWANo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_styles__WEBPACK_IMPORTED_MODULE_1__/* .WaNoDp */ .xx, {
                onClick: onContactBtnClick,
                children: storePhone
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WhatsAppIconComp);


/***/ }),

/***/ 979021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cy": function() { return /* binding */ HeaderSectionListItem; },
/* harmony export */   "sN": function() { return /* binding */ MenuItem; },
/* harmony export */   "xx": function() { return /* binding */ WaNoDp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        ";\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  color: ",
        ";\n  position: relative;\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 13px;\n  font-size: 15px;\n  color: #101010;\n  box-shadow: 0px 3px 6px #00000029;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  position: absolute;\n  top: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: pointer;\n\n  &::before {\n    content: '';\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    position: absolute;\n    border-bottom: 10px solid #ffffff;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n\n  & > p {\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var MenuItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "MenuItem",
    componentId: "sc-d21082bf-0"
})(_templateObject(), function(props) {
    return props.margin || "0 0 0 20px";
}, function(props) {
    return props.secondaryColor;
});
var WaNoDp = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "WaNoDp",
    componentId: "sc-d21082bf-1"
})(_templateObject1());
var HeaderSectionListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "HeaderSectionListItem",
    componentId: "sc-d21082bf-2"
})(_templateObject2());


/***/ }),

/***/ 472579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ whatsappMessageRender; }
/* harmony export */ });
/* harmony import */ var _getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(230066);

/**
 * common function to open whatsapp for messaging the store owner
 * display/registered number
 * @param {Object} - userData, phoneNumber, storeUrl
 */ var whatsappMessageRender = function() {
    (0,_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_0__/* .openWhatsAppLeadModal */ .iM)();
};


/***/ })

}]);